export const helpColorsTop = [506, 221, 427];
